import { Menu, MenuPopupBody } from '@/popups/menupopup/menu'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { isNFCSupported } from '@/env/tools/nfc/writer'

export interface SimpleCard {
  userId: string
  username: string
  ucid: string
  createdAt: string
}

export interface UserGroup {
    id: string
    name: string
    createdAt: string
}

export type UserGroupsResponse = UserGroup[];

export const extendCommunalCardsMenuPopup = ({ menu, services, session, row, navigate }: {
    menu: Menu
    services: Services
    session: CurrentSession
    row: SimpleCard
    navigate: (url: string) => void
}): Menu => {
    return {
        ...menu,
        rows: [
            ...(isNFCSupported() ? [{
                icon: 'svgfont-nfc',
                title: 'elements.table.cards.menu.edit.card_write',
                action: async () => {
                    const response: UserGroupsResponse = await services.session
                        .fetchWithToken(`/api/communal/groups/foruser/${row.userId}`)
                        .then(async (r) => {
                            if (r.status !== 200) {
                                const erros = await r.json()
                                console.error(erros)
                                return Promise.reject<UserGroupsResponse>()
                            }
                            return (await r.json()) as UserGroupsResponse
                        })

                    const hasWjo2 = response.some((g: any) => typeof g?.name === "string" && g.name.toLowerCase().includes("wjo2"))
                    const hasWjo3 = response.some((g: any) => typeof g?.name === "string" && g.name.toLowerCase().includes("wjo3"))

                    const params = new URLSearchParams()
                    if (hasWjo2) params.set("wjo2", "true")
                    if (hasWjo3) params.set("wjo3", "true")
                    params.set("addUrl", "true")

                    const url = params.toString() ? `/tool/nfc/pgswriter?${params.toString()}` : `/tool/nfc/pgswriter`
                    navigate(url)
                }
            }] : []),
            ...menu.rows
        ]
    }
}